export enum MetadataFieldValueCardinality {
  One = "One",
  N = "N",
}
